module.exports = __webpack_public_path__ + "static/media/PitchedRoofImg5.1ab80cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PitchedRoofImg5.jpg
// module id = 1141
// module chunks = 0